import { makeStyles } from "@material-ui/core";
import React from "react";

import { REACTION_EMOJIS, isSameReaction } from "./reactionEmoji";

const useStyles = makeStyles(() => ({
	icons: {
		position: "absolute",
		top: "-50px",
		left: "50px",
		padding: "0 0.4rem",
		background: "white",
		borderRadius: "20px",
		display: "flex",
		gap: "5px",
	},
}));

export const ReactionsMsg = ({ onSelect, tailwickLayout = false, activeEmoji = "" }) => {
	const classes = useStyles();

	if (tailwickLayout) {
		return (
			<div className="tailwick-reactions-popup" role="menu">
				{REACTION_EMOJIS.map((item) => {
					const selected = isSameReaction(activeEmoji, item.value);
					return (
						<button
							key={item.value}
							type="button"
							role="menuitem"
							className={`tailwick-reactions-popup__emoji${selected ? " tailwick-reactions-popup__emoji--active" : ""}`}
							onClick={() => onSelect(selected ? "" : item.value)}
							aria-label={selected ? `Remover ${item.label}` : item.label}
							title={selected ? `Remover ${item.label}` : item.label}
							aria-pressed={selected}
						>
							<span className="tailwick-reactions-popup__glyph" aria-hidden>
								{item.emoji}
							</span>
						</button>
					);
				})}
			</div>
		);
	}

	return (
		<div className={classes.icons}>
			{REACTION_EMOJIS.map((item) => {
				const selected = isSameReaction(activeEmoji, item.value);
				return (
					<span
						key={item.value}
						onClick={() => onSelect(selected ? "" : item.value)}
						style={{
							cursor: "pointer",
							fontSize: "1.5rem",
							margin: "5px",
							opacity: selected ? 1 : 0.85,
							transform: selected ? "scale(1.15)" : "none",
						}}
						title={selected ? `Remover ${item.label}` : item.label}
					>
						{item.emoji}
					</span>
				);
			})}
		</div>
	);
};
